import { apiRequest } from './apiWrapper'
import { API_METHOD, API_END_POINT } from '../utils/constants'

export async function fetchFirebaseToken(
    device_name,
    device_id,
    device_type,
    push_token
) {
    const response = await apiRequest({
        method: API_METHOD.Post,
        url: API_END_POINT.firebaseToken,
        data: { device_name, device_id, device_type, push_token }
    })
    return response
}

export async function fetchNotificationData(uuid, filtersCsv) {
    const response = await apiRequest({
        method: API_METHOD.Get,
        url: API_END_POINT.notification,
        params: { uuid, filter: filtersCsv },
        skipCache: true
    })
    return response
}

export async function deleteNotificationById(id) {
    const response = await apiRequest({
        method: API_METHOD.Patch || 'patch',
        url: API_END_POINT.deleteNotification || '/v1/comm/push/notifications/delete',
        data: { _id: id }
    })
    return response
}

